"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixWhereClauseNesting = void 0;
const types_1 = require("./types");
const fixWhereClauseNesting = (expression, where) => {
    var _a, _b, _c, _d, _e;
    // if where clause is just one filter, no need to fix
    if (!!(where === null || where === void 0 ? void 0 : where.filter)) {
        return where;
    }
    const isEQL = expression.startsWith('select');
    const whereClause = isEQL
        ? (_c = (_b = ((_a = expression.match(/where (.*)( order| group)?/i)) !== null && _a !== void 0 ? _a : [])[1]) === null || _b === void 0 ? void 0 : _b.replace(/where /i, '')) === null || _c === void 0 ? void 0 : _c.replace(/( order| group)(.*)/i, '')
        : expression;
    const brackets = (_e = (_d = whereClause === null || whereClause === void 0 ? void 0 : whereClause.match(/(\(|\)|and|or)/gi)) === null || _d === void 0 ? void 0 : _d.join('')) === null || _e === void 0 ? void 0 : _e.replace(/and|or/gi, 'O');
    if (!brackets) {
        return where;
    }
    const rootBrackets = getRootBrackets(brackets);
    if (rootBrackets === 1) {
        return where;
    }
    for (let i = 0; i < rootBrackets - 1; i++) {
        where = {
            op: {
                type: types_1.OperationType.AND,
                params: [where],
            },
        };
    }
    return where;
};
exports.fixWhereClauseNesting = fixWhereClauseNesting;
const getRootBrackets = (brackets) => {
    let i = 1;
    for (; i < brackets.length; i++) {
        const withoutIBrackets = brackets.slice(i, brackets.length - i);
        if (!areBracketsBalanced(withoutIBrackets)) {
            break;
        }
    }
    return i - 1;
};
const areBracketsBalanced = (brackets) => {
    let openBrackets = 0;
    for (let i = 0; i < brackets.length; i++) {
        const curr = brackets[i];
        if (curr === '(') {
            openBrackets = openBrackets + 1;
        }
        else if (curr === ')') {
            openBrackets = openBrackets - 1;
        }
        if (openBrackets < 0) {
            break;
        }
    }
    return openBrackets === 0;
};
